import moment from "moment-timezone"
import { FEATURE_CINECLUB_DATE, metadata } from "lacinetek-common/src/metadata"
import { useTranslation } from "lib/i18n/translation"

export const Intro = ({ club, loading }) => {
	const { c } = useTranslation("common")

	return (
		<section>
			<h1 className="main-title large">{c("cineclub")}</h1>
			<div className="introduction splitted">
				<p>
					<strong>{c("presented-by")}</strong> {presentedSplitter(club.descriptionShort, c, true)}
				</p>
				<p className="align-right">
					{moment(metadata(club, FEATURE_CINECLUB_DATE), "DD/MM/YYYY hh:mm").format(`dddd DD MMMM YYYY [${c("at")}] HH[h]mm`)}
				</p>
			</div>
		</section>
	)
}

export const presentedSplitter = (names, c, invert) => {
	let result = names

	if (names) {
		const splitter = names.split(/, | et /)
		if (splitter.length == 1) {
			return (
				<><strong>{splitter[0]}</strong></>
			)
		}
		else if (splitter.length == 2) {
			if (invert) {
				return (
					<>{splitter[0]} <strong>{c("and")}</strong> {splitter[1]}</>
				)
			} else {
				return (
					<><strong>{splitter[0]}</strong> {c("and")} <strong>{splitter[1]}</strong></>
				)
			}
		} else {
			result = (
				<>
					{splitter.slice(0, splitter.length - 1).map((splitter, index) => (
						<>
							{invert
								? <>{splitter}{(index < (splitter.length - 2)) ? <strong>, </strong> : ""}</>
								: <><strong>{splitter}</strong>{(index < (splitter.length - 2)) ? <strong>, </strong> : ""}</>
							}
						</>
					))}
				</>
			)
			if (invert) {
				result = (
					<>
						{result} <strong>{c("and")}</strong> {splitter[splitter.length - 1]}
					</>
				)
			} else {
				result = (
					<>
						{result} {c("and")} <strong>{splitter[splitter.length - 1]}</strong>
					</>
				)
			}
		}
	}
	return result
}
